import React from 'react'

const  DashboardRental = () => {
  return (
        <table class="table table-responsive dasboardDataTable">
            <thead>
                <tr>
                <th scope="col" className='tableHead'>Rental ID</th>
                <th scope="col" className='tableHead'>GPU</th>
                <th scope="col" className='tableHead'>Spec</th>
                <th scope="col" className='tableHead'>Payment</th>
                <th scope="col"></th>

                </tr>
            </thead>
            <tbody>
                <tr>
                    <td># 2154 5684</td>
                    <td>NVIDIA GH200 Grace Hopper<sup>TM</sup></td>
                    <td className='d-flex gap-2 justify-content-between me-4'>
                        <span className='d-flex flex-column'>
                            <span className='specHeading'>VPCU</span>
                            <span className='specValue'>
                                <span>24</span> VCPU
                            </span>
                        </span>
                        <span className='d-flex flex-column'>
                            <span className='specHeading'>VPCU</span>
                            <span className='specValue'>
                                <span>24</span> VCPU
                            </span>
                        </span>
                        <span className='d-flex flex-column'>
                            <span className='specHeading'>VPCU</span>
                            <span className='specValue'>
                                <span>24</span> VCPU
                            </span>
                        </span>
                        <span className='d-flex flex-column'>
                            <span className='specHeading'>VPCU</span>
                            <span className='specValue'>
                                <span>24</span> VCPU
                            </span>
                        </span>
                    </td>
                    <td>$830/week</td>
                    <td className='table_btn'>
                        <button className='header_btn gradient-cta position-relative' >Cancel</button> 
                    </td>
                </tr>
                <tr>
                    <td># 2154 5684</td>
                    <td>NVIDIA GH200 Grace Hopper<sup>TM</sup></td>
                    <td className='d-flex gap-2 justify-content-between me-4'>
                        <span className='d-flex flex-column'>
                            <span className='specHeading'>VPCU</span>
                            <span className='specValue'>
                                <span>24</span> VCPU
                            </span>
                        </span>
                        <span className='d-flex flex-column'>
                            <span className='specHeading'>VPCU</span>
                            <span className='specValue'>
                                <span>24</span> VCPU
                            </span>
                        </span>
                        <span className='d-flex flex-column'>
                            <span className='specHeading'>VPCU</span>
                            <span className='specValue'>
                                <span>24</span> VCPU
                            </span>
                        </span>
                        <span className='d-flex flex-column'>
                            <span className='specHeading'>VPCU</span>
                            <span className='specValue'>
                                <span>24</span> VCPU
                            </span>
                        </span>
                    </td>
                    <td>$830/week</td>
                    <td className='table_btn'>
                        <button className='header_btn gradient-cta position-relative' >Cancel</button> 
                    </td>
                </tr>
                <tr>
                    <td># 2154 5684</td>
                    <td>NVIDIA GH200 Grace Hopper<sup>TM</sup></td>
                    <td className='d-flex gap-2 justify-content-between me-4'>
                        <span className='d-flex flex-column'>
                            <span className='specHeading'>VPCU</span>
                            <span className='specValue'>
                                <span>24</span> VCPU
                            </span>
                        </span>
                        <span className='d-flex flex-column'>
                            <span className='specHeading'>VPCU</span>
                            <span className='specValue'>
                                <span>24</span> VCPU
                            </span>
                        </span>
                        <span className='d-flex flex-column'>
                            <span className='specHeading'>VPCU</span>
                            <span className='specValue'>
                                <span>24</span> VCPU
                            </span>
                        </span>
                        <span className='d-flex flex-column'>
                            <span className='specHeading'>VPCU</span>
                            <span className='specValue'>
                                <span>24</span> VCPU
                            </span>
                        </span>
                    </td>
                    <td>$830/week</td>
                    <td className='table_btn'>
                        <button className='header_btn gradient-cta position-relative' >Cancel</button> 
                    </td>
                </tr>
                <tr>
                    <td># 2154 5684</td>
                    <td>NVIDIA GH200 Grace Hopper<sup>TM</sup></td>
                    <td className='d-flex gap-2 justify-content-between me-4'>
                        <span className='d-flex flex-column'>
                            <span className='specHeading'>VPCU</span>
                            <span className='specValue'>
                                <span>24</span> VCPU
                            </span>
                        </span>
                        <span className='d-flex flex-column'>
                            <span className='specHeading'>VPCU</span>
                            <span className='specValue'>
                                <span>24</span> VCPU
                            </span>
                        </span>
                        <span className='d-flex flex-column'>
                            <span className='specHeading'>VPCU</span>
                            <span className='specValue'>
                                <span>24</span> VCPU
                            </span>
                        </span>
                        <span className='d-flex flex-column'>
                            <span className='specHeading'>VPCU</span>
                            <span className='specValue'>
                                <span>24</span> VCPU
                            </span>
                        </span>
                    </td>
                    <td>$830/week</td>
                    <td className='table_btn'>
                        <button className='header_btn gradient-cta position-relative' >Cancel</button> 
                    </td>
                </tr>
            </tbody>
        </table>
   
  )
}

export default DashboardRental